/**
 * Web no-op analytics client — Phase 1 is mobile-only.
 */
import type {
  AnalyticsAttributionProperties,
  AnalyticsBranchAttributionProperties,
  AnalyticsClient,
  AnalyticsIdentifyTraits,
  AnalyticsInitConfig,
} from './types';
import type { AnalyticsEventName, AnalyticsProps } from './events';

const noopClient: AnalyticsClient = {
  init: async (_config: AnalyticsInitConfig) => {},
  identify: (
    _distinctId: string,
    _traits?: AnalyticsIdentifyTraits,
  ) => {},
  reset: () => {},
  track: (_event: AnalyticsEventName, _properties?: AnalyticsProps) => {},
  trackOnce: async (
    _storageKey: string,
    _event: AnalyticsEventName,
    _properties?: AnalyticsProps,
  ) => {},
  screen: (_screenName: string, _properties?: AnalyticsProps) => {},
  setAttribution: (_properties: AnalyticsAttributionProperties) => {},
  setBranchAttribution: (
    _properties: AnalyticsBranchAttributionProperties,
  ) => {},
};

export const analyticsClient: AnalyticsClient = noopClient;
